import React, { useEffect } from "react";
import { useVehicleStatus } from "./useVehicleStatus";
import RingChart from "Components/Charts/Ring/Ring";
import styles from "./VehicleStatus.module.scss";
import { Grid } from "@mui/material";
import Block from "Components/UI/Block/Block";
import { useAppDispatch } from "Redux/store";
import { getVehicleStatus } from "Redux/Dashboard/reducer";
import { Error } from "@mui/icons-material";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";

const VehicleStatus: React.FC = () => {
  const { statuses, loading, error, title } = useVehicleStatus();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getVehicleStatus());
  }, []);
  if (loading) return <SkeletonLoader />;
  return (
    <>
      {error && <Error onError={() => error} />}
      <Block className={styles.block}>
        <h3>Vehicle Status</h3>
        {!error && (
          <Grid
            container
            className={styles.status}
            justifyContent="space-between"
            mt="20px"
          >
            <Grid item xs={6.5}>
              <RingChart data={statuses} title={title} />
            </Grid>
            <Grid item xs={5.5} className={styles.status__data}>
              {statuses.map(({ name, value, itemStyle }) => (
                <div
                  key={name}
                  className={styles.status__data__item}
                  style={{ color: itemStyle.borderColor }}
                >
                  <div>{name}</div>
                  <div>{value}</div>
                </div>
              ))}
            </Grid>
          </Grid>
        )}
      </Block>
    </>
  );
};
export default VehicleStatus;
